import React from 'react'
import { QUICK_LINKS } from './mockData'

export default function QuickLinks() {
  return (
    <div>
      <div className="section-head">
        <h3>More</h3>
      </div>
      <div className="quick-row">
        {QUICK_LINKS.map((link, i) => (
          <a className="quick-pill" href={link.href} key={i}>
            <span className="qp-dot" style={{ background: link.dotColor }} />
            {link.label}
            {link.count && (
              <span style={{ fontFamily: 'var(--f-mono)', fontSize: '10.5px', color: link.dotColor, fontWeight: 600 }}>
                {link.count}
              </span>
            )}
          </a>
        ))}
      </div>
    </div>
  )
}
